import DoublePopoverConfirm from "@/components/DoublePopoverConfirm/DoublePopoverConfirm";
import { OrderType, useDeleteOrders } from "@/hooks/useOrders";
import useTranslation from "@/hooks/useTranslation";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { message } from "antd";
import { ReactNode } from "react";

export default function DeleteOrdersAction({
  orderType,
  year,
  disabled = false,
  children,
  onSuccess,
}: {
  orderType: OrderType;
  year?: number;
  disabled?: boolean;
  children: ReactNode;
  onSuccess?: () => void;
}) {
  const deleteOrders = useDeleteOrders();
  const translation = useTranslation();

  return (
    <DoublePopoverConfirm
      trigger={["click"]}
      title={"Delete orders"}
      description={
        <>
          <p>
            This action will permanently delete orders. Make sure to export your orders before you
            proceed.
          </p>
          <p>
            Deleting orders will not delete any products or facilities that have been created in the
            process of uploading them.
          </p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      onConfirm1={() =>
        deleteOrders
          .mutateAsync({ orderType })
          .then((result) => {
            if (result.status === 200) {
              message.success(`Successfully deleted ${result.data.count} orders.`);
              onSuccess && onSuccess();
            }
          })
          .catch(() => message.error(translation.errors.general))
      }
      onConfirm2={() =>
        deleteOrders
          .mutateAsync({ year, orderType })
          .then((result) => {
            if (result.status === 200) {
              message.success(`Successfully deleted ${result.data.count} orders.`);
              onSuccess && onSuccess();
            }
          })
          .catch(() => message.error(translation.errors.general))
      }
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      placement="bottom"
      button1Props={{
        children: "Delete all orders",
        danger: true,
      }}
      button2Props={{
        children: `Delete ${year} orders`,
        danger: true,
      }}
      cancelButtonProps={{ children: "Cancel" }}
      disabled={disabled}
    >
      {children}
    </DoublePopoverConfirm>
  );
}
